import {
    Checkbox,
    Flex,
    InfoIcon,
    Text,
    Tooltip,
} from "@fluentui/react-northstar";
import BadgeTemplates from "../../../components/Badge/BadgeTemplates";

// lorsque l'utilisateur il check le parent
export const onCheckParentList = ({
    template_id,
    checked,
    setStateTemplates,
}) => {
    return setStateTemplates((old_templates) => {
        const new_templates = old_templates?.map((template) => {
            if (template.id === template_id) {
                return {
                    ...template,
                    tasks: template.tasks?.map((task) => ({
                        ...task,
                        checked: checked,
                    })),
                    checked: checked,
                };
            }
            return template;
        });
        return new_templates;
    });
};

// lorsque l'utilisateur il check un Child
export const onCheckChildList = ({
    template_id,
    task_id,
    checked,
    setStateTemplates,
}) => {
    setStateTemplates((old_templates) => {
        return old_templates.map((template) => {
            if (template_id === template?.id) {
                const new_tasks = template.tasks?.map((task) => {
                    if (task.id === task_id) {
                        return {
                            ...task,
                            checked: checked,
                        };
                    }
                    return task;
                });

                const is_all_child_selected = new_tasks.every(
                    (task) => task.checked
                );
                const is_some_child_selected = new_tasks.some(
                    (task) => task.checked
                );
                const state_parent_checkbox = is_all_child_selected
                    ? true
                    : is_some_child_selected || checked
                    ? "mixed"
                    : false;

                return {
                    ...template,
                    tasks: new_tasks,
                    checked: state_parent_checkbox,
                };
            }
            return template;
        });
    });
};

export const _formatJsonTemplateToFuiPanels = ({
    stateTemplates = [],
    setStateTemplates,
    onCheckParentList = () => console.log("check list"),
    onCheckChildList = () => console.log("check child list"),
}) => {
    const initJson = stateTemplates
        .filter((el) => el?.type === "Offboarding")
        .map((el) => {
            return {
                key: "key_" + el?.id,
                title: (
                    <Flex
                        key={"title_" + el?.id}
                        vAlign="center"
                        styles={{
                            justifyContent: "space-between",
                            padding: "10px 15px 10px 0px",
                        }}
                    >
                        <Flex
                            gap="gap.small"
                            vAlign="center"
                            styles={{ marginLeft: "5px" }}
                        >
                            <Checkbox
                                label={
                                    <Text styles={{ fontWeight: "bold" }}>
                                        {el?.name}
                                    </Text>
                                }
                                onChange={(e, { checked }) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onCheckParentList({
                                        template_id: el?.id,
                                        checked,
                                        setStateTemplates,
                                    });
                                }}
                                styles={{
                                    height: "fit-content",
                                    padding: "0px!important",
                                }}
                                className="Accordion__checkbox--header"
                                data={el}
                                checked={el?.checked}
                            />
                            <Tooltip
                                content={el?.description}
                                trigger={<InfoIcon outline />}
                            />
                        </Flex>
                        <BadgeTemplates content={el?.type} />
                    </Flex>
                ),
                content: (
                    <Flex column key={"content_" + el?.id}>
                        {el?.tasks?.map((child) => {
                            return (
                                <Checkbox
                                    key={child?.id}
                                    label={<Text>{child?.name}</Text>}
                                    onChange={(e, { checked }) =>
                                        onCheckChildList({
                                            template_id: el?.id,
                                            checked,
                                            task_id: child?.id,
                                            setStateTemplates,
                                        })
                                    }
                                    styles={{
                                        borderBottom:
                                            "1px solid rgba(219, 219, 219, 0.5)",
                                        paddingBlock: "14px",
                                    }}
                                    className="Accordion__checkbox--children"
                                    data-parent={el}
                                    data-children={child}
                                    checked={child?.checked}
                                />
                            );
                        })}
                    </Flex>
                ),
            };
        });

    return initJson;
};
